// Chống crash trắng màn hình khi trình duyệt / app tự động dịch trang (Google Dịch, trình duyệt
// trong Facebook/Zalo, Samsung Internet...). Khi công cụ dịch thay đổi/bọc lại các text node,
// React cố gỡ hoặc chèn node theo cây ảo của nó nhưng cây thật đã bị đổi -> ném lỗi
// "Failed to execute 'removeChild' / 'insertBefore' on 'Node'" làm sập app.
// Bản vá: nếu node không còn đúng cha thì bỏ qua thao tác thay vì ném lỗi.
// (React issue #11538 - cách xử lý phổ biến.)
if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function removeChild(child) {
        if (child.parentNode !== this) {
            if (console) {
                console.warn('Bỏ qua removeChild trên node khác cha (do trang bị dịch).', child, this);
            }
            return child;
        }
        // eslint-disable-next-line prefer-rest-params
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (console) {
                console.warn('Bỏ qua insertBefore với node tham chiếu khác cha (do trang bị dịch).', referenceNode, this);
            }
            return newNode;
        }
        // eslint-disable-next-line prefer-rest-params
        return originalInsertBefore.apply(this, arguments);
    };
}
